<div mat-dialog-title>
  <h1>{{ 'security.changePassword' | transloco }}</h1>
  <button (click)="onCloseClick()" class="close-btn ms-auto"></button>
</div>

<div mat-dialog-content>
  <app-notification #notification [hidden]="!notification?.isShow" class="w-100"></app-notification>

  <form [formGroup]="pwdForm" (submit)="OnSubmit()" [hidden]="isComplete">
    <mat-form-field class="w-100" appearance="fill">
      <mat-label>{{ 'restorePwd.currentPassword' | transloco }}</mat-label>
      <input
        [type]="isHideCurrentPwd ? 'password' : 'text'"
        matInput
        id="currentPassword"
        formControlName="currentPassword"
        data-test="passwordChange_current-password"
      />
      <svg-icon matSuffix (click)="isHideCurrentPwd = !isHideCurrentPwd" [key]="isHideCurrentPwd ? 'closeEye' : 'eye'"></svg-icon>
      <mat-error *ngIf="pwdForm.get('currentPassword')?.hasError('required')">{{ 'errorCodes.REQUIRED' | transloco }}</mat-error>
    </mat-form-field>

    <mat-form-field class="w-100" appearance="fill">
      <mat-label>{{ 'restorePwd.password' | transloco }}</mat-label>
      <input
        [type]="isHidePwd ? 'password' : 'text'"
        matInput
        formControlName="password"
        (focus)="pwdFocusState = true"
        (focusout)="pwdFocusState = false"
        data-test="passwordChange_password"
      />
      <svg-icon matSuffix (click)="isHidePwd = !isHidePwd" [key]="isHidePwd ? 'closeEye' : 'eye'"></svg-icon>
      <mat-hint *ngIf="pwdFocusState" class="error-block">{{ 'restorePwd.passwordMustContain' | transloco }}</mat-hint>
      <mat-error *ngIf="pwdForm.get('password')?.hasError('required')">{{ 'errorCodes.REQUIRED' | transloco }}</mat-error>
      <mat-error *ngIf="pwdForm.get('password')?.hasError('pwdLowercase')">{{ 'restorePwd.passwordMustContain' | transloco }}</mat-error>
    </mat-form-field>

    <mat-error *ngIf="!pwdForm.get('password')?.invalid && pwdForm?.hasError('isNewPwd') && !!pwdForm.get('password')?.touched" class="ms-3">
      {{ 'restorePwd.passwordsMatches' | transloco }}</mat-error
    >

    <mat-form-field class="w-100" appearance="fill" [ngClass]="{ 'mat-form-field-invalid': pwdForm.value?.errors?.['passwordsNotMatch'] }">
      <mat-label>{{ 'restorePwd.verifyPwd' | transloco }}</mat-label>
      <input [type]="isHideVerifyPwd ? 'password' : 'text'" data-test="passwordChange_password-verify" matInput formControlName="verifyPwd" />
      <svg-icon matSuffix (click)="isHideVerifyPwd = !isHideVerifyPwd" [key]="isHideVerifyPwd ? 'closeEye' : 'eye'"></svg-icon>
    </mat-form-field>

    <mat-error *ngIf="pwdForm.hasError('passwordsNotMatch') && !!pwdForm.get('verifyPwd')?.touched" class="ms-3">{{
      'restorePwd.passwordsDoNotMatch' | transloco
    }}</mat-error>

    <button data-test="passwordChange_btn-save" type="submit" class="primary xl w-100 mt-2 mb-4" [disabled]="pwdForm.invalid">
      {{ 'restorePwd.confirmPasswordChange' | transloco }}
    </button>
  </form>
</div>
